import { memo } from 'react'

import { ContactAndComplaints, ContactUs } from './ContactAndComplaints'

export const ContactAndComplaintsCopy = memo(ContactAndComplaints)
export const ContactUsCopy = memo(ContactUs)
